<template>
  <v-alert outlined text type="info" v-if="message">
    <div class="title" style="white-space: pre-line">
      {{ message }}
    </div>
  </v-alert>
</template>
<script>
export default {
  name: "SuccessMessage",
  data: () => ({
    message: "",
    details: []
  }),

  watch: {
    successObject: "initialize"
  },
  props: {
    successObject: {
      type: Object,
      required: false,
      default: undefined
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      if (this.$route.params && this.$route.params.success) {
        const success = this.$route.params.success;
        this.setSuccess(success);
      } else if (this.successObject && this.successObject.success) {
        const success = this.successObject.success;
        this.setSuccess(success);
      } else {
        this.message = "";
        this.details = [];
      }
    },
    setSuccess(success) {
      this.message = "";
      this.details = [];
      if (success.message && success.message.value) {
        this.message = success.message.value;
      }
    }
  }
};
</script>
